module.exports = __webpack_public_path__ + "static/media/Imageweather.21047489.png";